enum UiSourceEnum {
    AdminArea = 'ADMIN_AREA',
    BrokerPortal = 'BROKER_PORTAL',
    ExpressQuote = 'EXPRESS_QUOTE',
    ReferralPartner = 'REFERRAL_PARTNER',
}

export default UiSourceEnum;
